import React, { useState, useEffect } from "react";
import { toast } from "../../../../components/toastNotification";
import TextInput from "../../../../components/TextInput";
import { useRecoilState } from "recoil";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import OfficeTypeForm from "./OfficeTypeForm";
import AddButton from "../../../../components/AddButton";

import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";

import useOfficeType from "./hooks/useOfficeType";
import useDeleteOfficeType from "./hooks/useDeleteOfficeType";
import useUpdateOfficeType from "./hooks/useUpdateOfficeType";
import {
  addStateOfficeType,
  selectedRowsStateOfficeType,
  setFilterTextOfficeType,
} from "./atoms/atoms";
import TableFilters from "../TableFilters";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import EditButton from "../../../../components/EditButton";
import { useQueryClient } from "react-query";
import MaterialOfficeConfigTable from "../../../../components/tables/MaterialOfficeConfigTable";

const OfficeTypeTable = () => {
  //Hooks Call
  const { data, isFetching } = useOfficeType();
  const { mutateAsync: UpdateOfficeType } = useUpdateOfficeType();
  const BulkDeleteOfficeType = useDeleteOfficeType();
  //Atoms Call
  const [actionAddState, setActionAddState] =
    useRecoilState(addStateOfficeType);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateOfficeType
  );
  const [filterText, setFilterText] = useRecoilState(setFilterTextOfficeType);
  //Local States
  const [rowsCount, setRowsCount] = useState(0);
  const [editRowId, setEditRowId] = useState(null);
  const [actionEditState, setActionEditState] = useState(false);
  const [, setEmpTypeIsExistState] = useState(false);
  const [empTypeDataIsChange, setEmpTypeDataIsChange] = useState(false);
  const [displayNote] = useState(false);
  const [edit, setEdit] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [hasOfficeTypeType, setHasOfficeTypeType] = useState(true);
  const [, setIsBulkSelected] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [hideColumn, sethideColumn] = useState(false);
  const [officeTypeFilteredData, setOfficeTypeFilteredData] = useState([]);
  const queryClient = useQueryClient();
  const [editRowData, setEditRowData] = useState();

  const addPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officetype_add;
  const editPermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officetype_edit;
  const deletePermission =
    PERMISSIONS.permission_utilities_officeconfiguration_officetype_delete;

  const userPermissions = useRecoilValue(permissionsSelector);
  const defaultValues = {
    officeTypeId: 0,
    officeTypeName: "",
    glnumber: "",
  };
  const [empNewData, setNewData] = useState([defaultValues]);
  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state == null) {
    //Do nothing
  } else {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setOfficeTypeFilteredData(result);
          setOfficeTypeId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {
        //console.log("error " + error);
      }
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);
  useEffect(() => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    setActionAddState(false);
    setActionEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleCheckBox = (checked) => {
    setEmpTypeDataIsChange(true);
    checked ? setCheckStatus(true) : setCheckStatus(false);
    checked
      ? empNewData.map((x) => (x.isActive = true))
      : empNewData.map((x) => (x.isActive = false));
  };

  const handleEditFieldsChange = (SourceType, fieldName, row, inputvalue) => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    inputvalue = inputvalue.trim();
    if (SourceType === "OfficeTypeType") {
      if (fieldName === "officeTypeName") {
        setEmpTypeDataIsChange(true);
        const result = data.filter(
          (item) =>
            item.officeTypeName.toUpperCase() === inputvalue.toUpperCase()
        )[0];
        empNewData.map((x) => (x.officeTypeName = inputvalue));
      }
      if (fieldName === "glnumber") {
        setEmpTypeDataIsChange(true);
        const result = data.filter((item) => item.glnumber === inputvalue)[0];
        result !== undefined
          ? setEmpTypeIsExistState(true)
          : empNewData.map((x) => (x.glnumber = inputvalue));
      }
      inputvalue === ""
        ? setHasOfficeTypeType(false)
        : setHasOfficeTypeType(true);
    }
  };

  const handleEditButton = (rowData) => {
    setEditRowId(rowData.officeTypeId);
    setEdit(true);
    setEmpTypeDataIsChange(false);
    setCheckStatus(rowData.isActive);
    setEditRowData({ ...rowData });
    empNewData.map((x) => (x.isActive = rowData.isActive));
    empNewData.map((x) => (x.officeTypeId = rowData.officeTypeId));
    empNewData.map((x) => (x.officeTypeName = rowData.officeTypeName));
    empNewData.map((x) => (x.glnumber = rowData.glnumber));
    empNewData.map((x) => (x.createdBy = rowData.createdBy));
    empNewData.map((x) => (x.createdOn = rowData.createdOn));
  };

  //Save changes
  const handleSave = (empNewData) => {
    setOpenModalEdit(false);
    if (actionEditState) {
      UpdateOfficeType(empNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModalEdit(false);
          } else if (
            empNewData[0].officeTypeName === editRowData.officeTypeName &&
            empNewData[0].isActive === editRowData.isActive
          ) {
            toast.fire("Saving Failed", "No Changes have been made", "warning");
            setOpenModalEdit(false);
          } else {
            setNewData([defaultValues]);
            setEditRowId([]);
            setSelectedRows([]);
            setOpenModalEdit(false);
            setActionEditState(false);
            setDisabledButton(false);
            sethideColumn(false);
            setEdit(false);
            queryClient.invalidateQueries(["GetOfficeTypes"]);
            toast.fire(
              "Success",
              "Office Type Updated Successfully",
              "success"
            );
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Update Office Type", "error");
          queryClient.invalidateQueries(["GetOfficeTypes"]);
          setOpenModalEdit(false);
        },
      });
    }
  };
  // end of saving changes

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.officeTypeId);
    BulkDeleteOfficeType(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "Office Types" : "Office Type"
    }?`}</div>
  );

  const matColumns = [
    {
      title: "Office Type Name",
      field: "officeTypeName",
      customSort: (a, b) =>
        a.officeTypeName && b.officeTypeName
          ? a.officeTypeName.trim().localeCompare(b.officeTypeName.trim())
          : a.officeTypeName
          ? 0
          : -1,
      render: (rowData) => {
        return rowData.officeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="Office Type"
              defaultValue={rowData.officeTypeName}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "OfficeTypeType",
                  "officeTypeName",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <>{rowData.officeTypeName}</>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.createdBy}</>
        );
      },
    },
    {
      title: "Created Date",
      field: "createdOn",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData.createdOn
              ? new Date(rowData.createdOn).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Modified Date",
      field: "UpdatedOn",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData.updatedOn
              ? new Date(rowData.updatedOn).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Modified By",
      field: "updatedBy",
      hidden: hideColumn,
      render: (rowData) => {
        return rowData.officeTypeId === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.updatedBy}</>
        );
      },
    },

    {
      title: "Status",
      field: "isActive",
      align: "left",
      render: (rowData) => {
        return rowData.officeTypeId === editRowId ? (
          <div className="flex justify-start space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handleCheckBox(e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {checkStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      render: (rowData) => {
        return !userPermissions.includes(editPermission) ? (
          ""
        ) : rowData.officeTypeId === editRowId ? (
          <div className="flex place-content-center gap-2 ">
            <SaveButton
              className={`flex shadow-md text-xs font-semibold text-white  gap-x-1 rounded-full  bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
            ${
              !hasOfficeTypeType || !empTypeDataIsChange
                ? "opacity-50"
                : "opactiy-100"
            }`}
              disabled={!hasOfficeTypeType || !empTypeDataIsChange}
              onClick={() => {
                setOpenModalEdit(true);
              }}
            />
            <CancelButton
              className="flex text-xs shadow-md font-semibold text-white ml-1 gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
              onClick={() => {
                setActionEditState(false);
                setEditRowId([]);
                setEmpTypeDataIsChange(false);
                setEmpTypeIsExistState(false);
                setDisabledButton(false);
                sethideColumn(false);
                setEdit(false);
              }}
            />
          </div>
        ) : (
          <div className="flex items-center place-content-center mr-5">
            <EditButton
              disabled={disabledButton || selectedRows.length > 0}
              className={
                disabledButton || selectedRows.length > 0
                  ? "opacity-50 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
                  : "opacity-100 rounded-full items-center bg-quaternary text-white hover:bg-hquaternary"
              }
              onClick={() => {
                setDisabledButton(true);
                setActionEditState(true);
                handleEditButton(rowData);
                sethideColumn(true);
              }}
            />
          </div>
        );
      },
    },
  ];

  //Filters
  const [officeTypeId, setOfficeTypeId] = useState("");
  useEffect(() => {
    if (filterText) {
      setOfficeTypeFilteredData(
        data?.filter((x) =>
          x.officeTypeName
            ?.toLowerCase()
            .includes(filterText.trim()?.toLowerCase())
        )
      );
    } else if (officeTypeId?.includes(".")) {
      let officeTypeIds = officeTypeId.split(".");
      const officeTypeIdsArr = officeTypeIds.map((id) => Number(id));
      const filteredData = data?.filter((x) =>
        officeTypeIdsArr.includes(x.officeTypeId)
      );

      setOfficeTypeFilteredData(filteredData);
    } else {
      const filteredData = data?.filter(
        (x) => x.officeTypeId === Number(officeTypeId)
      );
      setOfficeTypeFilteredData(filteredData);
    }
  }, [filterText, data]);

  return (
    <div className="animate-fade-in-down w-full">
      {actionAddState ? (
        ""
      ) : (
        <div className="font-bold text-primary text-xl uppercase ">
          {" "}
          {/* <h1>Office Type</h1>{" "} */}
        </div>
      )}
      {!actionAddState && (
        <div className="">
          <div className="flex w-full">
            <div className="bg-white w-full p-4">
              <div className="flex flex-row justify-between items-center">
                <div className="">
                  <TableFilters
                    filterText={setFilterText}
                    moduleDetails="Office Type Name"
                    textInputName="officeTypeName"
                    disabledButton={disabledButton || selectedRows.length > 0}
                  ></TableFilters>
                </div>
                <div className="">
                  {userPermissions.includes(addPermission) ? (
                    <AddButton
                      buttonText="New Office Type"
                      className={
                        selectedRows.length > 0 || actionEditState
                          ? "opacity-50"
                          : "opacity-100"
                      }
                      onClick={() => setActionAddState(!actionAddState)}
                      disabled={disabledButton || selectedRows.length > 0}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>

              {userPermissions.includes(deletePermission) ? (
                <div className="text-secondary italic text-xs3 my-2">
                  <p className="font-bold italic inline-block mr-1">Note:</p>
                  <span>Tick the box to deactivate some data.</span>
                </div>
              ) : (
                <div className="mb-4"></div>
              )}

              <div className="">
                <MaterialOfficeConfigTable
                  columns={matColumns}
                  data={
                    officeTypeFilteredData?.length > 0
                      ? officeTypeFilteredData
                      : data
                      ? filterText === ""
                        ? data
                        : officeTypeFilteredData
                      : []
                  }
                  options={{
                    toolbar: false,
                    showTitle: false,
                  }}
                  selection={
                    !actionEditState &&
                    userPermissions.includes(deletePermission)
                  }
                  setOpenModal={setOpenModalDelete}
                  onSelectionChange={handleSelectedRowsChange}
                  selectedRows={selectedRows}
                  isDeactivate={true}
                  isLoading={isFetching}
                />
              </div>
            </div>
          </div>
          <ConfirmBoxModal
            ModalTitle="Update Office Type"
            qConfirmation=" Are you sure you want to update this?"
            isOpen={openModalEdit}
            onClose={() => {
              setOpenModalEdit(false);
              sethideColumn(true);
            }}
            onClickFunction={() => {
              handleSave(empNewData);
            }}
          />
          <ConfirmBoxDelete
            ModalTitle="Deactivate Office Type"
            qConfirmation={deleteMessage}
            isOpen={openModalDelete}
            onClose={() => setOpenModalDelete(false)}
            onClickFunction={handleBulkDelete}
          />
        </div>
      )}
      {actionAddState && (
        <div className="p-4">
          <OfficeTypeForm />
        </div>
      )}
      {/* </div> */}
    </div>
  );
};

export default OfficeTypeTable;
